export default class CreateVoyageData {
    constructor(routeId, routeTheyrId, vesselId, vesselTheyrId, companyId, description, startTime, options,) {
        this.routeId = routeId
        this.routeTheyrId = routeTheyrId
        this.vesselId = vesselId
        this.vesselTheyrId = vesselTheyrId
        this.companyId = companyId
        this.description = description
        this.startTime = startTime
        this.options = options
    }
}
//options -> VoyageRouteOptions
